(function () {
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || '[]');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return []; }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ---------- Saved pieces (hearts) ---------- */
  var SAVED = 'fo:saved';
  function savedCount() {
    var n = store(SAVED).length;
    $$('[data-saved-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function initHearts(scope) {
    var saved = store(SAVED);
    $$('[data-save]', scope).forEach(function (b) {
      if (b._fo) return; b._fo = true;
      var h = b.getAttribute('data-save');
      b.setAttribute('aria-pressed', saved.indexOf(h) > -1 ? 'true' : 'false');
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var list = store(SAVED), i = list.indexOf(h);
        if (i > -1) list.splice(i, 1); else list.unshift(h);
        store(SAVED, list.slice(0, 60));
        $$('[data-save="' + h + '"]').forEach(function (x) { x.setAttribute('aria-pressed', i > -1 ? 'false' : 'true'); });
        savedCount();
      });
    });
  }
  window.foInitHearts = initHearts;

  function fetchCards(handles, grid, limit, done) {
    var out = [], pending = Math.min(handles.length, limit);
    if (!pending) { done(0); return; }
    handles.slice(0, limit).forEach(function (h, idx) {
      fetch(root + 'products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; })
        .then(function (html) {
          out[idx] = html.trim();
          if (--pending === 0) {
            var good = out.filter(Boolean);
            grid.innerHTML = good.join('');
            if (good.length < 3) grid.classList.add('grid--few');
            initHearts(grid);
            done(good.length);
          }
        });
    });
  }

  // Saved page
  $$('[data-saved-grid]').forEach(function (grid) {
    var empty = document.querySelector('[data-saved-empty]');
    fetchCards(store(SAVED), grid, 60, function (n) { if (empty) empty.hidden = n > 0; });
  });

  /* ---------- Recently viewed ---------- */
  var RECENT = 'fo:recent';
  var cur = document.querySelector('[data-recent-current]');
  var curHandle = cur ? cur.getAttribute('data-recent-current') : null;
  $$('[data-recent-grid]').forEach(function (grid) {
    var list = store(RECENT).filter(function (h) { return h !== curHandle; });
    var sec = grid.closest('[data-recent-section]');
    fetchCards(list, grid, parseInt(grid.getAttribute('data-limit') || '4', 10), function (n) { if (sec) sec.hidden = n === 0; });
  });
  if (curHandle) {
    var r = store(RECENT).filter(function (h) { return h !== curHandle; });
    r.unshift(curHandle);
    store(RECENT, r.slice(0, 12));
  }

  /* ---------- Search suggestions ---------- */
  $$('[data-predictive-form]').forEach(function (form) {
    var input = form.querySelector('input[type=search]');
    var box = form.parentNode.querySelector('[data-predictive]');
    if (!input || !box) return;
    var t, last = '';
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { box.innerHTML = ''; box.hidden = true; return; }
      t = setTimeout(function () {
        last = q;
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (q !== last) return;
            var res = (data.resources && data.resources.results) || {};
            var html = '';
            (res.collections || []).slice(0, 3).forEach(function (c) {
              html += '<a class="predict__col" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
            });
            (res.products || []).forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              html += '<a class="predict__item" href="' + esc(p.url) + '">' +
                (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="48" height="60" loading="lazy">' : '<span></span>') +
                '<span><small>' + esc(p.vendor) + '</small>' + esc(p.title) + '</span>' +
                '<span class="predict__price">' + (p.available === false ? 'Sold' : '$' + esc(p.price)) + '</span></a>';
            });
            html += '<a class="predict__all" href="' + root + 'search?type=product&q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
            box.innerHTML = html;
            box.hidden = false;
          })
          .catch(function () { box.hidden = true; });
      }, 220);
    });
  });

  /* ---------- Slide-out cart ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  function openDrawer() {
    drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var c = drawer.querySelector('[data-cart-close]'); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function refreshDrawer(note) {
    return fetch(root + '?sections=fo-cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['fo-cart-drawer'];
        var fresh = tmp.querySelector('[data-cart-drawer]');
        if (fresh && drawer) {
          drawer.innerHTML = fresh.innerHTML;
          var count = fresh.getAttribute('data-count') || '0';
          $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === '0'; });
        }
        if (note) {
          var n = drawer.querySelector('[data-cart-note]');
          if (n) { n.textContent = note; n.hidden = false; }
        }
      });
  }
  if (drawer) {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener) { e.preventDefault(); refreshDrawer().then(openDrawer); return; }
      if (e.target.closest('[data-cart-close]') || e.target === drawer) { closeDrawer(); return; }
      var rm = e.target.closest('[data-remove-line]');
      if (rm) {
        e.preventDefault();
        fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: parseInt(rm.getAttribute('data-remove-line'), 10), quantity: 0 }) })
          .then(function () { return refreshDrawer(); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
    $$('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btns = $$('[name=add]').concat($$('button[form="' + form.id + '"]'));
        btns.forEach(function (b) { b.disabled = true; });
        fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) { return refreshDrawer(res.ok ? '' : (res.j.description || res.j.message || 'This piece is already in your cart.')); })
          .then(openDrawer)
          .catch(function () { form.submit(); })
          .then(function () { btns.forEach(function (b) { b.disabled = false; }); });
      });
    });
  }

  initHearts(document);
  savedCount();
})();